/* eslint-disable no-nested-ternary */
import * as vp from 'vopay';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import frenchLocale from './MomentLocale/fr';
import { useAccountVerification } from '../../../providers/AccountVerification.provider';
import { useLayout } from '../../../providers/Layout.provider';
import styles from './AccountVerification.module.scss';
import BrandingLogo from '../../UI/BrandingLogo/BrandingLogo';

const { Box, Button, Title } = vp;

type FC = FunctionComponent;

const AccountVerification: FC = () => {
  const history = useHistory();
  const { color, setLayoutInfo } = useLayout();
  const { verificationInfo, verificationRequests, brandingInfo } = useAccountVerification();
  const { t, i18n } = useTranslation('translations', { keyPrefix: 'VerifyAccount' });

  useEffect(() => {
    frenchLocale();
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', brandingInfo?.BrandingDetails?.PrimaryColor),
      'curve',
      '',
      80,
      20,
      0,
      false,
      true,
    );
  }, [brandingInfo]);

  useEffect(() => {
    moment.locale(i18n.language !== 'en' ? 'fr' : 'en');
  }, [i18n.language]);
  useEffect(() => {
    if (
      verificationRequests.Success &&
      verificationRequests.VerificationRequests[0].Status.Verification !== 'unverified'
    ) {
      history.push(`/connect/verification/${verificationRequests.VerificationRequests[0].Status.Verification}`);
    } else if (
      verificationRequests.Success &&
      verificationRequests.VerificationRequests[0].Status.Request === 'expired'
    ) {
      history.push(`/connect/verification/expired`);
    }
  }, [verificationRequests]);

  return (
    <Box jc="center" ai="center" flx="col">
      <Box maxwidth="566px" flx="col" height="auto">
        <Box flx="col" pb="md">
          {brandingInfo?.Logo && (
            <Box jc="center" pb="md">
              <BrandingLogo src={brandingInfo?.Logo} />
            </Box>
          )}
          <Title title={`${t('title')}`} size="lg" bold />
        </Box>
        <div className={styles.description}>
          <p>
            <span>{verificationInfo.Name}</span> {`${t('requestSent')}`} {`${t('requestNote')}`}{' '}
            {moment(verificationInfo.ExtraInfo.VerificationDetails?.VerificationStartDate)
              .add(verificationInfo.ExtraInfo.VerificationDetails?.ExpireDate, 'd')
              .lang(i18n.language)
              .format('MMM DD YYYY')}
            .
          </p>
          <p>
            {`${t('fulfillRequest')}`} {`${t('chargeStatement')}`}
          </p>
          <p>{`${t('confirmAmount')}`}</p>
        </div>
        <Box flx="col" pt="lg">
          <Button
            id="continue-verification-btn"
            label={`${t('buttons.continue')}`}
            width="100%"
            background={color}
            textColor={vp.getContrastColor(color)}
            textSize={1}
            fontWeight={500}
            size="xlg"
            round
            noShadow
            bold
            onClick={() => {
              history.push('/connect/amount-verification');
            }}
          />
        </Box>
      </Box>
      <div className={styles.mobileImage} />
    </Box>
  );
};

export default AccountVerification;
